<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Tag
      </h1>
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'dashboard' }">
            <i class="fa fa-dashboard"></i> Home
          </router-link>
        </li>
        <li>
          <router-link :to="{name: 'tag-index'}">
            Tags
          </router-link>
        </li>
        <li class="active">
          <span v-if="isCreate">Create</span>
          <span v-else>Edit</span>
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">{{ title }}</h3>
            </div>

            <form class="form-horizontal" @submit.prevent="submit">
              <div class="box-body" style="overflow: unset;">
                <div v-if="error" class="alert alert-danger">
                  <a class="close" @click="error = false">
                    &times;
                  </a>
                  {{ error }}
                </div>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-2 control-label">
                    Name <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      placeholder="Name"
                      v-model="form.name">
                  </div>
                </div>

                <div class="form-group">
                  <label for="name_en"
                    class="col-sm-2 control-label">
                    Name EN<span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="name_en"
                      placeholder="Name EN"
                      v-model="form.name_en">
                  </div>
                </div>

                <div class="form-group">
                  <label for="slug"
                    class="col-sm-2 control-label">
                    Slug
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="slug"
                      placeholder="Slug"
                      v-model="form.slug">
                  </div>
                </div>
              </div>
              <div class="box-footer">
                <button type="submit" class="btn btn-info pull-right" v-if="isCreate">Create</button>
                <button type="submit" class="btn btn-info pull-right" v-else>Update</button>
                <div v-if="error" class="alert alert-danger">
                  <a class="close"
                    @click="error = false">
                    &times;
                  </a>
                  {{ error }}
                </div>
                <a class="btn btn-default" @click.prevent="cancel">Cancel</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Common from '@/mixins/Common';

export default {
  name: 'TagForm',

  mixins: [Common],

  data() {
    return {
      title: 'Add New Tag',

      form: {
        id: null,
        name: null,
        name_en: null,
        slug: null,
      },

      error: null,
    };
  },

  props: {
    isCreate: {
      type: Boolean,
      required: false,
    },
  },

  methods: {
    fetch() {
      this.axios.get(`/tags/${this.$route.params.id}`)
        .then((response) => {
          const { data } = response.data;
          this.form.id = data.id;
          this.form.name = data.name;
          this.form.name_en = data.name_en;
          this.form.slug = data.slug;
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data.errors;
          }
        });
    },

    validate() {
      if (!this.form.name) {
        this.$swal('Name required', 'Please fill name to continue', 'warning');
        return false;
      }

      if (!this.form.name_en) {
        this.$swal('Name EN required', 'Please fill name en to continue', 'warning');
        return false;
      }

      return true;
    },

    submit() {
      const result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },

    create() {
      this.axios.post('/tags', this.stringify(this.form))
        .then(() => {
          this.$router.push({
            name: 'tag-index',
          });
        })
        .catch((error) => {
          if (error.response) {
            this.$swal({
              title: 'Failed',
              text: 'Oppss! Name already used',
              type: 'error',
              timer: 8000,
            });
          }
        });
    },

    update() {
      this.axios.put(`/tags/${this.form.id}`, this.stringify(this.form))
        .then(() => {
          this.$router.push({
            name: 'tag-index',
          });
        })
        .catch((error) => {
          if (error.response) {
            this.$swal({
              title: 'Failed',
              text: 'Oppss! Name already used',
              type: 'error',
              timer: 8000,
            });
          }
        });
    },

    cancel() {
      this.$router.go(-1);
    },
  },

  created() {
    if (!this.isCreate) {
      this.fetch();
      this.title = 'Edit Tag';
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/tags/Form.vue